module.exports = "data:text/x-markdown;base64,Q29uZ3JhdHMhIFJlZmVyZW5jZTogW3JBQVZFIEZhcm1pbmcgQ29udHJhY3QgRXhwbG9pdCBleHBsYWluZWRdKGh0dHBzOi8vZ3Jvd3RoZGVmaS5tZWRpdW0uY29tL3JhYXZlLWZhcm1pbmctY29udHJhY3QtZXhwbG9pdC1leHBsYWluZWQtZjNiNmYwYjNjMWIzKQo="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/discolp_complete.md
// module id = 1830
// module chunks = 0